import ExclamationCircleAlt from "@bloomberg/web-icons-react/ExclamationCircleAlt";
import { T } from "@bbnpm/bb-ui-framework";
import "./error.min.css";

const Error = () => {
    const SITE_ADDRESS = process.env.PUBLIC_URL + "/";
    const htmlTitle = sanitizeHTML(window.SETTINGS.bannerErrorTitle);
    const htmlDetails = sanitizeHTML(window.SETTINGS.bannerErrorDetails);

    function sanitizeHTML(backendHTML) {
        return backendHTML
            .replaceAll("&amp;", "&")
            .replaceAll("&lt;", "<")
            .replaceAll("&gt;", ">")
            .replaceAll("&#39;", "'")
            .replaceAll("&#34;", "'");
    }

    return (
        <div className="errorContainer">
            {/* T.BodyLarge on the container: the nested prose inherits the token. */}
            <T.BodyLarge as="div" className="error">
                <div className="content">
                    <div className="message">
                        <ExclamationCircleAlt className="error-icon" />
                        <div>
                            <T.H1 as="h1" className="page-title">
                                {htmlTitle}
                            </T.H1>
                            {htmlDetails ? <code>{htmlDetails}</code> : null}
                        </div>
                    </div>
                    <hr />
                    <div className="resourceContainer">
                        <div></div>
                        <div className="resourceContent">
                            <T.BodyLarge>Here are some helpful links:</T.BodyLarge>
                            <a href={SITE_ADDRESS + "help"} rel="noreferrer">
                                BBA Help
                            </a>
                            <a href={SITE_ADDRESS} rel="noreferrer">
                                Return Home
                            </a>
                        </div>
                    </div>
                </div>
            </T.BodyLarge>
        </div>
    );
};

export default Error;
